import { Trans } from '@lingui/macro'

import * as React from 'react'

import { MessageBox, MessageBoxText } from '~ui/components/MessageBox/MessageBox'
import { Text } from '~ui/components/typography/Text/Text'

/**
 * Message box to alert people that in their order is a product which requires age verification.
 */
export const AgeControlMessageBox = () => {
  const intendedFor18Plus = (
    <Text as={`span`} fontStyle={`bold`}>
      <Trans comment='products that are "intended for people over 18 years old"'>
        intended for people over 18 years old
      </Trans>
    </Text>
  )

  return (
    <MessageBox bgColor={`alert`} gap={`extraSmall`}>
      <MessageBoxText>
        <Trans>Your cart contains items {intendedFor18Plus}.</Trans>
        {` `}
        <Trans>Your age will be verified when you receive your order.</Trans>
      </MessageBoxText>
    </MessageBox>
  )
}
